import * as yup from "yup";

export const OFFICE_EMAIL_EDIT_FORM_SCHEMA = yup.object().shape({
  emailAddress: yup.string().email().required("Molimo Vas da unesete email"),
});
